import { z } from "zod";
import { HttpMethodEnum, Route } from "../../../../utils/route";
import { zStringDate } from "@dobrh-monorepo/core";

const responseSchema = z.object({
  availableBalance: z.number(),
  holdBalance: z.number(),
  pendingPayoutAmount: z.number(),
  expectedEarningAmount: z.number(),
  lastPayoutDate: zStringDate().optional(),
  lastPayoutRequestDate: zStringDate().optional(),
});

export default {
  method: HttpMethodEnum.GET,
  responseZodSchema: responseSchema,
} satisfies Route;
